@if (alertConcluirPedido) {
  <div class="body-alert">
    <div class="tamanhoBox">
      <div class="row mt-3">
        <div class="col-lg-12">
          <h1 class="titulo">Revise as informações do pedido</h1>
        </div>
      </div>
      <div class=" lista-beneficios-ul">
        @if (benefitDetails?.produtos) {
          <table class="table table-hover border-bottom mt-4">
            <thead>
              <tr>
                <th scope="col-1">CÓDIGO</th>
                <th scope="col-5">DESCRIÇÃO</th>
                <th scope="col-2">QUANTIDADE</th>
                <th scope="col-2">UNIDADE</th>
                <th scope="col-2">SUBTOTAL</th>
              </tr>
            </thead>
            <tbody>
              @for (order of benefitDetails?.produtos; track order; let i = $index) {
                <tr>
                  <td>{{ order.codVenda }}</td>
                  <td>{{ order.descricao }}</td>
                  <td>{{ order.qtde }}</td>
                  <td>{{ order.valorUnitario }}</td>
                  <td>{{ order.subTotal }}</td>
                </tr>
              }
            </tbody>
          </table>
        }
      </div>
      <div class="ajuste-row table-vale-papel"
        style="display: flex;justify-content: space-between; height: 91px;">
        <div style="width: 17%;margin-left: 14px;margin-right: 14px">
          <p>Total de Vales</p>
          <span>{{benefitDetails?.totalVales}}</span>
        </div>
        <div style="width: 17%;margin-left: 14px;margin-right: 14px">
          <p>Outras Cobranças</p>
          <span>{{benefitDetails?.totalOutrasCobrancas}}</span>
        </div>
        <div style="width: 17%;margin-left: 14px;margin-right: 14px">
          <p>Total da taxa</p>
          <span>{{benefitDetails?.totalTaxa}}</span>
        </div>
        <div style="width: 17%;margin-left: 14px;margin-right: 14px">
          <p>Descontos</p>
          <span>{{benefitDetails?.totalDescontos}}</span>
        </div>
        <div style="width: 30%;	border-left: 2px solid #D8D8D8;">
          <p style="margin: 35px 0 0 15px;color: #0E7F61!important;">Total a pagar: {{benefitDetails?.totalPagar}}</p>
        </div>
      </div>
      <div class="row">
      </div>
      <div class="row h-18" style="margin-left: -48px; margin-bottom: -12px; margin-right: -48px;">
        <div class="footer-alert footer w-90 h-100">
          <div class="text-end rodape ">
            <button type="button" class="btn botao-outline w-auto" id="btnCancelar" (click)='cancelarAlterarEmpresa()' style="margin-right: 5px;">VOLTAR E EDITAR</button>
            <button class="btn btn-borda-verde bnt-font btn-grande-verde w-auto" id="btnConfirmar" (click)='onConfirmarPedido()'>CONCLUIR PEDIDO</button>
          </div>
        </div>
      </div>
    </div>
  </div>
}
